const record = (value: unknown): Record<string, unknown> | undefined =>
  value && typeof value === "object" ? value as Record<string, unknown> : undefined;

/** A provider finish reason is meaningful even when the HTTP connection stays open. */
export function completionStatus(value: unknown): { finished: boolean; reason?: string; errorCode?: string } {
  const data = record(value);
  if (!data) return { finished: false };
  if (["finish-step", "text-end", "reasoning-end", "response.output_text.done", "response.output_item.done"].includes(String(data.type))) return { finished: false };
  const choice = Array.isArray(data.choices) ? record(data.choices[0]) : undefined;
  const response = record(data.response);
  const incomplete = record(response?.incomplete_details ?? data.incomplete_details);
  const rawReason = choice?.finish_reason ?? choice?.finishReason ?? data.finish_reason ?? data.finishReason ?? incomplete?.reason;
  const reason = typeof rawReason === "string" && rawReason ? rawReason : undefined;
  const type = data.type;
  const errorCode = reason && ["length", "max_tokens", "max_output_tokens"].includes(reason)
    ? "output_limit"
    : reason === "content_filter" ? "output_filtered"
    : type === "response.failed" || type === "response.incomplete" ? "inference_failed" : undefined;
  return {
    finished: Boolean(reason) || data.done === true || type === "finish" || type === "message_stop" || type === "response.completed" || type === "response.failed" || type === "response.incomplete",
    ...(reason ? { reason } : {}),
    ...(errorCode ? { errorCode } : {}),
  };
}
